import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './navigation-mobile.scss';

class MobileNavItem extends PureComponent {
  constructor() {
    super();

    this.state = {
      height: 0
    };
  }

  componentDidMount() {
    const isActive = this.props.activeTabIndex === this.props.index;
    const height = !isActive ? 0 : this.list.clientHeight;

    this.setState({ height });
  }

  componentWillReceiveProps({ opened }) {
    if (opened !== this.props.opened) {
      const height = !opened ? 0 : this.list.clientHeight;

      this.setState({ height });
    }
  }

  onToggleClick = () => {
    this.props.onItemClick(this.props.index);
  };

  render() {
    const { activeTabIndex, index } = this.props;

    const classes = {
      'mobile-subnav-head-active': activeTabIndex === index
    };

    return (
      <div className="mobile-subnav">
        <button
          className={cn('btn mobile-subnav-head', classes)}
          onClick={this.onToggleClick}
        >
          {this.props.label}
        </button>

        <div
          className="mobile-subnav-list"
          style={{ height: `${this.state.height}px` }}
        >
          <ul ref={elem => { this.list = elem; }}>
            {this.props.links.map(({ title, pathname }, key) =>
              <li key={key}>
                <Link
                  to={pathname}
                  activeClassName="mobile-subnav-active"
                  dangerouslySetInnerHTML={{ __html: title }}
                />
              </li>
            )}
          </ul>
        </div>
      </div>
    );
  }
}

MobileNavItem.propTypes = {
  index: PropTypes.number,
  opened: PropTypes.bool,
  label: PropTypes.string,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      pathname: PropTypes.string
    })
  )
};

class MobileNavList extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      openedIndex: this.props.activeTabIndex
    };
  }

  onItemClick = (index) => {
    const openedIndex = index === this.state.openedIndex ? null : index;
    this.setState({ openedIndex });
  };

  render() {
    return (
      <ul className="mobile-nav-list">
        {this.props.links.map((item, index) =>
          <li key={index}>
            <MobileNavItem
              index={index}
              activeTabIndex={this.props.activeTabIndex}
              opened={this.state.openedIndex === index}
              links={item.links}
              label={item.button}
              onItemClick={this.onItemClick}
            />
          </li>
        )}
      </ul>
    );
  }
}

MobileNavList.propTypes = {
  activeTabIndex: PropTypes.number,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      pathname: PropTypes.string
    })
  )
};

class NavigationMobile extends PureComponent {
  render() {
    return (
      <div className="mobile-nav-container">
        <MobileNavList
          activeTabIndex={this.props.activeTabIndex}
          links={this.props.links}
        />

        <button
          type="button"
          className="btn btn-flex solid-black"
          onClick={() => this.props.onPanelSwitch('login')}
        >
          <em>Вход<span className="icon">→</span></em>
          Личный кабинет
        </button>

        <button
          type="button"
          className="btn btn-flex solid-turq"
          onClick={() => this.props.onPanelSwitch('subscribe')}
        >
          <em>подписаться на рассылку<span className="icon">→</span></em>
          Инвестиционный клуб
        </button>
      </div>
    );
  }
}

NavigationMobile.propTypes = {
  activeTabIndex: PropTypes.number,
  links: PropTypes.array
};

export default NavigationMobile;




// WEBPACK FOOTER //
// ./src/components/Layout/Navigation/NavigationMobile.js